import { ReactElement } from 'react';
import { AlertProps } from 'antd';
import { SAlert } from './alert.component.styles.ts';

const Alert = (props: AlertProps): ReactElement => (<SAlert {...props}/>);

export default Alert;
